import { inertNativeBridge } from '../providers/IoContext';
export const noopNativeAuthTokenStore = {
    persist: ()=>{},
    clear: ()=>{}
};
export const boot = async (deps)=>{
    if (!deps.isNativePlatform()) {
        deps.mount({
            nativeBridge: inertNativeBridge,
            nativeAuthTokenStore: noopNativeAuthTokenStore
        });
        return;
    }
    deps.addPlatformBodyClass(deps.getNativePlatform());
    try {
        const { nativeBootstrap, makeNativeBridge, makeNativeIntercomClient } = await deps.loadNative();
        const config = await nativeBootstrap.resolveConfig();
        nativeBootstrap.applyRuntimeConfig(nativeBootstrap.applyNativeOverrides(config));
        await deps.initNativeI18n(await nativeBootstrap.readStoredLocale());
        // WHY: must run before hydrate — clears a stale keychain token on fresh install so hydrate can't re-arm a dead session.
        await nativeBootstrap.clearStaleNativeAuthTokenOnFreshInstall();
        await nativeBootstrap.hydrateNativeAuthTokenFromPreferences();
        const nativeAuthTokenStore = nativeBootstrap.makeNativeAuthTokenStore();
        const nativeBridge = await makeNativeBridge({
            navigate: deps.navigate,
            minNativeVersion: config.minNativeVersion,
            iosAppStoreId: config.iosAppStoreId
        });
        deps.mount({
            nativeBridge,
            nativeAuthTokenStore,
            nativeIntercomClient: makeNativeIntercomClient()
        });
    } catch (err) {
        // WHY: catch-all (BootstrapNetworkError, ChunkLoadError on broken OTA, etc.) → retry screen; Capgo rolls back next launch.
        deps.renderRetry(err);
    }
};
